import { styled, IconButton as MuiIconButton, Typography, Stack, Box } from "@mui/material";

export const PanelContainer = styled(Stack)(({ theme }) => ({
  width: "360px",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  backgroundColor: theme.palette.system[0],
  paddingBottom: 2
}));

export const Header = styled(Stack)(({ theme }) => ({
  position: "sticky",
  top: 0,
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  paddingInline: theme.spacing(2),
  paddingBlock: "15.5px",
  borderBottom: `1px solid ${theme.palette.system[200]}`,
  backgroundColor: theme.palette.system[0],
  zIndex: 1,
  height: "64px"
}));

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.text[900],
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "20px"
}));

export const Content = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "isLoading"
})(({ theme, isLoading }) => ({
  padding: theme.spacing(2),
  flex: 1,
  minHeight: 0,
  overflowY: isLoading ? "visible" : "auto",
  gap: theme.spacing(2.25)
}));

export const IconButton = styled(MuiIconButton)({
  padding: 0
});

export const EmptyStateContainer = styled(Stack)(({ theme }) => ({
  transform: "translateY(-20px)",
  height: "100%",
  padding: theme.spacing(2),
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center"
}));

export const EmptyStateTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  marginTop: theme.spacing(2)
}));

export const EmptyStateSubtitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.caption,
  marginTop: theme.spacing(0.2),
  maxWidth: "230px"
}));

export const VirtualizedListContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "height"
})(({ height }) => ({
  height,
  width: "100%",
  position: "relative"
}));

export const VirtualizedRow = styled("div", {
  shouldForwardProp: (prop) => prop !== "top" && prop !== "height"
})(({ top, height }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  transform: `translateY(${top}px)`,
  height: `${height}px`,
}));

export const VirtualizedHeader = styled(Typography)(({ theme }) => ({
  ...theme.typography.tableHeader1,
  color: theme.palette.text[800],
}));
